<template>
  <div class="page-container">
    <main class="main-content">
      <section class="topbar">
        <div v-if="carouselList.length > 0" class="study-carousel">
             <el-carousel :interval="5000" arrow="hover" height="360px" indicator-position="outside">
               <el-carousel-item v-for="item in carouselList" :key="item.id">
                 <div :style="getBannerStyle(item)" class="carousel-slide" @click="openAd(item)">
                   <div class="overlay"></div>
                 </div>
               </el-carousel-item>
             </el-carousel>
        </div>
        <div class="page-inner-box topbar-inner">
          <div
            v-if="carouselList.length === 0 && topBannerAd"
            class="banner"
            :style="getBannerStyle(topBannerAd)"
            @click="openAd(topBannerAd)"
          >
            <el-button v-if="topBannerAd.buttonText && topBannerAd.buttonText.length > 0 " type="primary" size="small" @click.stop="openAd(topBannerAd)">{{ topBannerAd.buttonText }}</el-button>
          </div>

          <div class="filters">
            <div class="tabs">
              <div 
                v-for="tab in tabs" 
                :key="tab" 
                class="tab-item" 
                :class="{ active: currentTab === tab }"
                @click="currentTab = tab"
              >
                {{ tab }}
              </div>
            </div>

            <div v-if="level2List.length > 0" class="row">
              <span class="label">{{ level1 === '商品' ? '分类' : '一级分类' }}：</span>
              <div class="chips">
                <span class="filter-link" :class="{active: level2==='全部'}" @click="level2='全部'">全部</span>
                <el-tag v-for="c in level2List" :key="c" effect="plain" :class="{ active: level2===c }" @click="level2=c">{{ c }}</el-tag>
              </div>
            </div>
            
            <div v-if="level1 !== '商品' && level3List.length > 0" class="row">
              <span class="label">二级分类：</span>
              <div class="chips">
                <span class="filter-link" :class="{active: level3==='全部'}" @click="level3='全部'">全部</span>
                <el-tag v-for="c in level3List.slice(0,10)" :key="c" effect="plain" :class="{ active: level3===c }" @click="level3=c">{{ c }}</el-tag>
              </div>
              <el-dropdown v-if="level3List.length > 10" @command="handleLevel3Command">
                <span class="more-toggle el-dropdown-link">
                  更多 <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item 
                    v-for="c in level3List.slice(10)" 
                    :key="c" 
                    :command="c"
                    :disabled="level3 === c"
                  >
                    {{ c }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="level1 === '商品'" class="row">
              <span class="label">排序：</span>
              <el-select v-model="productSortType" size="small" style="width:140px">
                <el-option label="付款数量" value="salesCount" />
                <el-option label="价格" value="price" />
                <el-option label="上架时间" value="createTime" />
              </el-select>
              <el-select v-model="productSortOrder" size="small" style="width:120px">
                <el-option label="降序" value="desc" />
                <el-option label="升序" value="asc" />
              </el-select>
            </div>
            <div v-if="level1 !== '商品'" class="row price-row">
              <div class="row">
                <span class="label">价格区间：</span>
                <div class="row">
                  <a class="filter-link" :class="{active: priceMin==null && priceMax==null}" @click="priceMin=null; priceMax=null; applyPrice()">全部</a>
                  <el-input v-model.number="priceMin" size="small" placeholder="元" style="width:120px" />
                  <span>—</span>
                  <el-input v-model.number="priceMax" size="small" placeholder="元" style="width:120px" />
                  <el-button size="small" type="primary" @click="applyPrice">确定</el-button>
                </div>
              </div>


              <el-button size="small" @click="resetFilters">重置筛选条件</el-button>
            </div>
          </div>
        </div>
      </section>

      <section class="list">
        <div class="page-inner-box">

          <div class="grid">
            <RecommendCard
              v-for="p in pagedProducts"
              :key="p.id"
              :course="p"
              @click="goAction(p)"
            />
          </div>

        </div>
      </section>

    <AdPopup v-if="popupAd" :ad="popupAd" page-id="study" />
    <AdFloat v-if="floatAd" :ad="floatAd" />
    <AuthDialog 
      :show-login="loginVisible" 
      :show-register="registerVisible"
      @close-login="loginVisible=false"
      @close-register="registerVisible=false"
    />

    <QuickPurchaseDialog
      :visible.sync="showPurchaseDialog"
      :bizType="purchaseBizType"
      :itemId="purchaseItemId"
      :title="purchaseTitle"
      :image="purchaseImage"
      :price="purchasePrice"
      @purchased="handlePurchased"
    />

    </main>

  </div>
</template>

<script>
import { addAdvertisementView, getAdvertisementList, getCourseList, getHomeCategoryTree } from '@/api/courseApi'
import { getPaperList } from '@/api/examApi'
import { getClassList, getClassCategoryTree } from '@/api/classApi'
import { getMallCategoryList, getMallProductList } from '@/api/mallApi'
import QuickPurchaseDialog from '@/components/QuickPurchaseDialog.vue'
import AdPopup from '@/components/AdPopup.vue'
import AdFloat from '@/components/AdFloat.vue'
import RecommendCard from '@/components/RecommendCard.vue'
import AuthDialog from '@/components/AuthDialog.vue'

const defaultCourseCover = require('@/assets/image/study_placeholder.png')
const studyFiltersStorageKey = 'study_filters_v1'

export default {
  name: 'AppStudy',
  components: { QuickPurchaseDialog, AdPopup, AdFloat, RecommendCard, AuthDialog },
  data() {
    return {
      keyword: '',
      currentTab: '课程',
      tabs: ['课程', '班级', '试卷', '商品'],
      priceMin: null,
      priceMax: null,
      level1List: ['课程','模拟试卷','商品'],
      level2List: [],
      level3List: [],
      level1: '课程',
      level2: '全部',
      level3: '全部',
      courseCategoryTree: [],
      courseCategoryLoading: false,
      classCategoryTree: [],
      classCategoryLoading: false,
      mallCategories: [],
      mallCategoryLoading: false,
      productSortType: 'salesCount',
      productSortOrder: 'desc',
      products: [],
      totalProducts: 0,
      loading: false,
      topBannerAd: null,
      carouselList: [],
      popupAd: null,
      popupVisible: false,
      floatAd: null,
      floatVisible: false,
      adLoading: false,
      page: 1,
      pageSize: 200,
      restoringFilters: false,
      loginVisible: false,
      registerVisible: false,
      showPurchaseDialog: false,
      purchaseBizType: 'course',
      purchaseItemId: null,
      purchaseTitle: '',
      purchaseImage: '',
      purchasePrice: 0
    }
  },
  created() {
    this.initFromRouteOrCache()
  },
  computed: {
    pagedProducts() {
      return this.products
    }
  },
  watch: {
    '$route.query.keyword'(next) {
      if (this.restoringFilters) return
      const keyword = String(next || '').trim()
      if (keyword === this.keyword) return
      this.keyword = keyword
      this.page = 1
      this.fetchList()
    },
    priceMin() { this.page = 1 },
    priceMax() { this.page = 1 },
    productSortType() {
      if (this.restoringFilters) return
      if (this.level1 !== '商品') return
      this.page = 1
      this.fetchList()
    },
    productSortOrder() {
      if (this.restoringFilters) return
      if (this.level1 !== '商品') return
      this.page = 1
      this.fetchList()
    },
    currentTab() {
      if (this.restoringFilters) return
      this.page = 1
      this.handleTabUpdate()
    },
    level2() {
      if (this.restoringFilters) return
      this.page = 1
      this.handleLevel2Change()
    },
    level3() {
      if (this.restoringFilters) return
      this.page = 1
      this.fetchList()
    }
  },
  methods: {
    readFiltersFromSession() {
      try {
        const raw = sessionStorage.getItem(studyFiltersStorageKey)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed || typeof parsed !== 'object') return null
        return parsed
      } catch (e) {
        return null
      }
    },
    persistFiltersToSession() {
      if (this.restoringFilters) return
      try {
        const payload = {
          keyword: String(this.keyword || '').trim() || '',
          currentTab: this.currentTab,
          level2: this.level2,
          level3: this.level3,
          priceMin: this.priceMin == null || this.priceMin === '' ? null : Number(this.priceMin),
          priceMax: this.priceMax == null || this.priceMax === '' ? null : Number(this.priceMax),
          productSortType: this.productSortType,
          productSortOrder: this.productSortOrder,
          page: Number(this.page) || 1
        }
        sessionStorage.setItem(studyFiltersStorageKey, JSON.stringify(payload))
      } catch (e) {
        void e
      }
      this.syncFiltersToRouteQuery()
    },
    syncFiltersToRouteQuery() {
      const currentQuery = (this.$route && this.$route.query) || {}
      const nextQuery = { ...currentQuery }

      const keyword = String(this.keyword || '').trim()
      const currentTab = this.currentTab
      const level2 = this.level2
      const level3 = this.level3
      const priceMin = this.priceMin == null || this.priceMin === '' ? null : Number(this.priceMin)
      const priceMax = this.priceMax == null || this.priceMax === '' ? null : Number(this.priceMax)
      const productSortType = this.productSortType
      const productSortOrder = this.productSortOrder
      const page = Number(this.page) || 1

      const updates = {
        keyword: keyword || null,
        tab: currentTab && currentTab !== '课程' ? String(currentTab) : null,
        level1: null, // Clear legacy param
        level2: level2 && level2 !== '全部' ? String(level2) : null,
        level3: level3 && level3 !== '全部' ? String(level3) : null,
        priceMin: priceMin != null && Number.isFinite(priceMin) ? String(priceMin) : null,
        priceMax: priceMax != null && Number.isFinite(priceMax) ? String(priceMax) : null,
        productSortType: productSortType && productSortType !== 'salesCount' ? String(productSortType) : null,
        productSortOrder: productSortOrder && productSortOrder !== 'desc' ? String(productSortOrder) : null,
        page: page !== 1 ? String(page) : null
      }

      const managedKeys = Object.keys(updates)
      for (const key of managedKeys) {
        const val = updates[key]
        if (val == null || val === '') {
          delete nextQuery[key]
        } else {
          nextQuery[key] = val
        }
      }

      let changed = false
      for (const key of managedKeys) {
        const a = currentQuery[key]
        const b = nextQuery[key]
        if (String(a == null ? '' : a) !== String(b == null ? '' : b)) {
          changed = true
          break
        }
      }
      if (!changed) return

      this.$router.replace({ query: nextQuery }).catch(() => {})
    },
    applyRestoredFilters(raw) {
      if (!raw || typeof raw !== 'object') return
      
      let tab = raw.tab || raw.currentTab || raw.level1
      if (tab === '模拟试卷') tab = '试卷'
      
      if (tab && this.tabs.includes(tab)) {
        this.currentTab = tab
      } else if (tab === '图书' || tab === '学习机' || tab === '其他') {
        this.currentTab = '商品'
      }

      if (raw.level2 != null) this.level2 = String(raw.level2) || '全部'
      if (raw.level3 != null) this.level3 = String(raw.level3) || '全部'

      if (raw.priceMin == null || raw.priceMin === '') this.priceMin = null
      else this.priceMin = Number(raw.priceMin)
      if (raw.priceMax == null || raw.priceMax === '') this.priceMax = null
      else this.priceMax = Number(raw.priceMax)

      if (raw.productSortType != null) this.productSortType = String(raw.productSortType) || 'salesCount'
      if (raw.productSortOrder != null) this.productSortOrder = String(raw.productSortOrder) || 'desc'

      const pageNum = Number(raw.page)
      this.page = Number.isFinite(pageNum) && pageNum > 0 ? Math.floor(pageNum) : 1

      if (raw.keyword != null) this.keyword = String(raw.keyword || '').trim()
    },
    
    async initFromRouteOrCache() {
      this.restoringFilters = true
      try {
        const query = (this.$route && this.$route.query) || {}
        const queryHasFilters =
          query.tab != null ||
          query.level1 != null ||
          query.level2 != null ||
          query.level3 != null ||
          query.priceMin != null ||
          query.priceMax != null ||
          query.productSortType != null ||
          query.productSortOrder != null ||
          query.page != null ||
          query.keyword != null

        const cached = this.readFiltersFromSession()
        if (!queryHasFilters && cached) this.applyRestoredFilters(cached)
        if (queryHasFilters) this.applyRestoredFilters(query)
        await this.handleTabUpdate()
      } finally {
        this.restoringFilters = false
        this.persistFiltersToSession()
        this.fetchAdvertisements()
      }
    },
    sanitizeText(text) {
      return String(text || '').trim()
    },
    findCategoryIdByName(name, nodes) {
      const target = this.sanitizeText(name)
      if (!target) return null
      const list = Array.isArray(nodes) ? nodes.filter(Boolean) : []
      for (let i = 0; i < list.length; i++) {
        const node = list[i]
        const nodeName = this.sanitizeText(node && node.categoryName)
        if (nodeName && nodeName === target) {
          return node && node.id != null ? node.id : null
        }
        const children = node && node.children
        const found = this.findCategoryIdByName(target, children)
        if (found != null) return found
      }
      return null
    },
    normalizeCategoryNodes(nodes) {
      return Array.isArray(nodes) ? nodes.filter(Boolean) : []
    },
    getCategoryNames(nodes) {
      return this.normalizeCategoryNodes(nodes)
        .map(n => this.sanitizeText(n && n.categoryName))
        .filter(Boolean)
    },
    uniqueNames(list) {
      const seen = new Set()
      return (Array.isArray(list) ? list : []).filter(name => {
        const key = String(name || '').trim()
        if (!key || seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    getCurrentCategoryTree() {
      if (this.currentTab === '班级') {
        return this.classCategoryTree
      }
      return this.courseCategoryTree
    },
    findCategoryNodeByName(name) {
      const key = this.sanitizeText(name)
      if (!key) return null
      const tree = this.getCurrentCategoryTree()
      return this.normalizeCategoryNodes(tree).find(n => this.sanitizeText(n && n.categoryName) === key) || null
    },
    buildLevel3ListByLevel2Name(level2Name) {
      const tree = this.getCurrentCategoryTree()
      const node = this.findCategoryNodeByName(level2Name)
      if (!node) {
        const all = this.normalizeCategoryNodes(tree).flatMap(n => {
          const children = this.normalizeCategoryNodes(n && n.children)
          const hasGrandChildren = children.some(c => this.normalizeCategoryNodes(c && c.children).length > 0)
          if (hasGrandChildren) {
            return children.flatMap(c => this.getCategoryNames(c && c.children))
          }
          return this.getCategoryNames(children)
        })
        return this.uniqueNames(all)
      }

      const children = this.normalizeCategoryNodes(node && node.children)
      const hasGrandChildren = children.some(c => this.normalizeCategoryNodes(c && c.children).length > 0)
      if (hasGrandChildren) {
        return this.uniqueNames(children.flatMap(c => this.getCategoryNames(c && c.children)))
      }
      return this.uniqueNames(this.getCategoryNames(children))
    },
    async fetchCourseCategoryTree() {
      if (this.courseCategoryLoading) return
      this.courseCategoryLoading = true
      try {
        const res = await getHomeCategoryTree()
        const list = Array.isArray(res && res.data) ? res.data : []
        this.courseCategoryTree = list
      } catch (err) {
        this.courseCategoryTree = []
      } finally {
        this.courseCategoryLoading = false
      }
    },
    async fetchClassCategoryTree() {
      if (this.classCategoryLoading) return
      this.classCategoryLoading = true
      try {
        const res = await getClassCategoryTree()
        const list = Array.isArray(res && res.data) ? res.data : []
        this.classCategoryTree = list
      } catch (err) {
        this.classCategoryTree = []
      } finally {
        this.classCategoryLoading = false
      }
    },
    async fetchMallCategoryList() {
      if (this.mallCategoryLoading) return
      this.mallCategoryLoading = true
      try {
        const res = await getMallCategoryList()
        const list = Array.isArray(res && res.data) ? res.data : []
        const enabled = list.filter(item => {
          const status = item && item.status
          if (status == null) return true
          return Number(status) === 1
        })
        this.mallCategories = enabled
      } catch (err) {
        this.mallCategories = []
      } finally {
        this.mallCategoryLoading = false
      }
    },
    findMallCategoryIdByName(name) {
      const target = this.sanitizeText(name)
      if (!target || target === '全部') return null

      const list = Array.isArray(this.mallCategories) ? this.mallCategories : []
      const found = list.find(c => this.sanitizeText(c && c.categoryName) === target) || null
      return found && found.id != null ? found.id : null
    },
    async handleTabUpdate() {
      if (this.currentTab === '课程' || this.currentTab === '试卷') {
        this.level1 = this.currentTab === '课程' ? '课程' : '模拟试卷'
        if (!this.courseCategoryTree || this.courseCategoryTree.length === 0) {
          await this.fetchCourseCategoryTree()
        }

        const level2Names = this.getCategoryNames(this.courseCategoryTree)
        this.level2List = this.uniqueNames(level2Names)
        const nextLevel2 = this.level2
        const validLevel2 =
          nextLevel2 === '全部' || this.level2List.includes(String(nextLevel2 || '').trim())
        if (!validLevel2) this.level2 = '全部'

        this.level3List = this.buildLevel3ListByLevel2Name(this.level2)
        const nextLevel3 = this.level3
        const validLevel3 =
          nextLevel3 === '全部' || this.level3List.includes(String(nextLevel3 || '').trim())
        if (!validLevel3) this.level3 = '全部'

        if (!this.restoringFilters) {
          if (this.level2 !== '全部') this.level2 = '全部'
          if (this.level3 !== '全部') this.level3 = '全部'
        }
        this.fetchList()
        return
      }

      // 班级
      if (this.currentTab === '班级') {
        this.level1 = '班级'
        if (!this.classCategoryTree || this.classCategoryTree.length === 0) {
          await this.fetchClassCategoryTree()
        }

        const level2Names = this.getCategoryNames(this.classCategoryTree)
        this.level2List = this.uniqueNames(level2Names)
        const nextLevel2 = this.level2
        const validLevel2 =
          nextLevel2 === '全部' || this.level2List.includes(String(nextLevel2 || '').trim())
        if (!validLevel2) this.level2 = '全部'

        this.level3List = this.buildLevel3ListByLevel2Name(this.level2)
        const nextLevel3 = this.level3
        const validLevel3 =
          nextLevel3 === '全部' || this.level3List.includes(String(nextLevel3 || '').trim())
        if (!validLevel3) this.level3 = '全部'

        if (!this.restoringFilters) {
          if (this.level2 !== '全部') this.level2 = '全部'
          if (this.level3 !== '全部') this.level3 = '全部'
        }
        this.fetchList()
        return
      }

      // Products: 图书, 学习机, 其他
      this.level1 = '商品'
      if (!this.mallCategories || this.mallCategories.length === 0) {
        await this.fetchMallCategoryList()
      }
      
      const categoryNames = this.mallCategories.map(c => c.categoryName).filter(Boolean)
      this.level2List = categoryNames.length > 0 ? categoryNames : []
      
      if (!this.restoringFilters) {
        this.level2 = '全部'
        this.level3 = '全部'
      } else {
        if (this.level2 !== '全部' && !categoryNames.includes(this.level2)) {
          this.level2 = '全部'
        }
      }
      this.level3List = []
      this.fetchList()
    },
    handleLevel2Change() {
      if (this.level1 === '课程' || this.level1 === '模拟试卷' || this.level1 === '班级') {
        this.level3List = this.buildLevel3ListByLevel2Name(this.level2)
        const nextLevel3 = this.level3
        const validLevel3 =
          nextLevel3 === '全部' || this.level3List.includes(String(nextLevel3 || '').trim())
        if (!validLevel3) this.level3 = '全部'

        if (!this.restoringFilters) {
          if (this.level3 !== '全部') this.level3 = '全部'
        }
        this.fetchList()
        return
      }
      if (this.level1 === '商品') {
        if (!this.restoringFilters) {
          if (this.level3 !== '全部') this.level3 = '全部'
        }
        this.fetchList()
      }
    },
    normalizeAd(item) {
      const id = item && item.id != null ? item.id : ''
      const title = String((item && item.adTitle) || '').trim()
      const link = String((item && item.adLink) || '').trim()
      const image = String((item && item.adImage) || '').trim()
      const buttonTextRaw =
        (item && (item.adButtonText || item.buttonText || item.actionText)) || ''
      const buttonText = String(buttonTextRaw || '').trim() || ''

      return {
        id,
        title: title || '广告',
        link,
        image,
        buttonText,
        raw: item
      }
    },
    async fetchAdvertisements() {
      if (this.adLoading) return
      this.adLoading = true
      try {
        const res = await getAdvertisementList({ displayPosition: 'course_list' })
        const data = res && res.data
        const list =
          (Array.isArray(data) && data) ||
          (data && Array.isArray(data.list) && data.list) ||
          []
        const enabled = list.filter(item => Number(item && item.enableStatus) === 1 && Number(item && item.adStatus) === 1)

        // Process Popup Ads
        const popupAds = enabled.filter(item => String(item && item.adType) === 'popup')
        if (popupAds.length > 0) {
          const popupAd = popupAds[0]
          // 检查广告是否已经被关闭
          if (!this.isAdClosed(popupAd.id)) {
            this.popupAd = this.normalizeAd(popupAd)
            this.popupVisible = true
          }
        }

        // Process Carousel Ads
        const carouselAds = enabled.filter(item => String(item && item.adType) === 'carousel')
        if (carouselAds.length > 0) {
          this.carouselList = carouselAds.map(ad => this.normalizeAd(ad))
        } else {
          this.carouselList = []
        }

        // Process Banner Ads (For Top Banner - Fallback if no carousel)
        const bannerAds = enabled.filter(item => String(item && item.adType) === 'banner')
        if (bannerAds.length > 0) {
           this.topBannerAd = this.normalizeAd(bannerAds[0])
        }

        // Process Float Ads (For Bottom Right Float)
        const floatAds = enabled.filter(item => String(item && item.adType) === 'float')
        if (floatAds.length > 0) {
          const floatAd = floatAds[0]
          // 检查广告是否已经被关闭
          if (!this.isAdClosed(floatAd.id)) {
            this.floatAd = this.normalizeAd(floatAd)
            this.floatVisible = true
          }
        }

        // If legacy fallback needed:
        // If we found NO banner ads but we have generic ads, maybe use first one as banner?
        // But adhering to strict types is safer given the request.
        
      } catch (err) {
        this.topBannerAd = null
        this.popupAd = null
        this.floatAd = null
      } finally {
        this.adLoading = false
      }
    },
    getBannerStyle(ad) {
      const image = ad && ad.image ? String(ad.image) : ''
      if (image) {
        return {
          backgroundImage: `url(${image}), linear-gradient(90deg,#3E2CCD,#6A5AF9)`,
          backgroundSize: 'cover, cover',
          backgroundPosition: 'center, center',
          backgroundRepeat: 'no-repeat, no-repeat'
        }
      }
      return undefined
    },
    openAd(ad) {
      const url = String(ad && ad.link ? ad.link : '').trim()
      if (!url) return
      const id = ad && ad.id
      if (id != null && id !== '') {
        addAdvertisementView(id).catch(() => {})
      }
      window.open(url, '_blank', 'noopener')
    },
    normalizeCourseItem(item) {
      const id = item && item.id != null ? item.id : ''
      const courseName = item && item.courseName != null ? item.courseName : ''
      const subtitle = item && item.subtitle != null ? item.subtitle : ''
      const coverImage = item && item.coverImage != null ? item.coverImage : ''
      let currentPrice = item && item.currentPrice != null ? item.currentPrice : (item && item.salePrice != null ? item.salePrice : 0)
      const isHot = Boolean(item && item.isHot)
      const isDiscount = Boolean(item && item.isDiscount)
      const isPurchased = Boolean(item && item.isPurchased)
      const discountEndTime = item && item.discountEndTime
      const discountPrice = item && item.discountPrice != null ? Number(item.discountPrice) : null
      const salePrice = item && item.salePrice != null ? Number(item.salePrice) : 0
      
      if (discountPrice != null && discountPrice > 0) {
         const end = discountEndTime ? new Date(discountEndTime).getTime() : 0
         if (end > Date.now()) {
            currentPrice = discountPrice
         }
      }

      const sales = Number(item && (item.viewCount ?? item.sales ?? item.buyCount ?? item.studentCount) ? (item.viewCount ?? item.sales ?? item.buyCount ?? item.studentCount) : 0)
      const lessonCount = Number(item && (item.lessonCount ?? item.chapterCount) ? (item.lessonCount ?? item.chapterCount) : 0)
      const categoryName = item && item.categoryName ? item.categoryName : ''
      const ratingRaw = item && (item.starRating != null ? item.starRating : (item.star_rating != null ? item.star_rating : item.rating))
      const ratingNum = ratingRaw == null ? 0 : Number(ratingRaw)
      const rating = Number.isFinite(ratingNum) ? Math.min(5, Math.max(0, ratingNum)) : 0
      const badges = []
      if (isHot) badges.push('热门')

      return {
        id,
        title: String(courseName || ''),
        desc: String(subtitle || ''),
        price: Number(currentPrice || 0),
        sales,
        isHot,
        isDiscount,
        isPurchased,
        img: coverImage || defaultCourseCover,
        kind: 'course',
        badges,
        lessonCount,
        discountEndTime,
        discountPrice,
        salePrice,
        categoryName,
        rating,
        raw: item
      }
    },
    normalizePaperItem(paper) {
      const id = paper && paper.id != null ? paper.id : ''
      const title = paper && paper.paperName != null ? paper.paperName : ''
      const duration = paper && paper.duration != null ? Number(paper.duration) : 0
      const totalScore = paper && paper.totalScore != null ? Number(paper.totalScore) : 0
      const price = paper && paper.price != null ? Number(paper.price) : 0
      const coverImage = paper && paper.coverImage ? String(paper.coverImage) : ''
      const paperType = paper && paper.paperType != null ? Number(paper.paperType) : undefined
      const isPurchased = Boolean(paper && paper.isPurchased)
      const categoryName = paper && paper.categoryName ? paper.categoryName : ''
      return {
        id,
        title: String(title || ''),
        desc: '',
        price,
        sales: 0,
        img: coverImage || defaultCourseCover,
        kind: 'paper',
        paperType,
        durationText: duration ? `时长：${duration}分钟` : '',
        scoreText: totalScore ? `总分：${totalScore}分` : '',
        isPurchased,
        categoryName,
        raw: paper
      }
    },
    normalizeClassItem(cls) {
      const id = cls && cls.id != null ? cls.id : ''
      const title = cls && cls.className != null ? cls.className : ''
      const subtitle = cls && cls.subtitle != null ? cls.subtitle : ''
      const coverImage = cls && cls.coverImage ? String(cls.coverImage) : ''
      const price = cls && cls.price != null ? Number(cls.price) : 0
      const originalPrice = cls && cls.originalPrice != null ? Number(cls.originalPrice) : 0
      const sales = cls && cls.salesCount != null ? Number(cls.salesCount) : 0
      const courseCount = cls && cls.courseCount != null ? Number(cls.courseCount) : 0
      return {
        id,
        title: String(title || ''),
        desc: String(subtitle || ''),
        price,
        originalPrice,
        sales,
        img: String(coverImage || '') || defaultCourseCover,
        kind: 'class',
        courseCount,
        raw: cls
      }
    },
    normalizeMallProductItem(item) {
      const id = item && item.id != null ? item.id : ''
      const title = item && item.productName != null ? item.productName : ''
      const desc = item && item.introduction != null ? item.introduction : ''
      const coverImage = item && item.coverImage != null ? item.coverImage : ''
      const price = item && item.price != null ? Number(item.price) : 0
      const originalPrice = item && item.originalPrice != null ? Number(item.originalPrice) : 0
      const sales = item && item.salesCount != null ? Number(item.salesCount) : 0
      return {
        id,
        title: String(title || ''),
        desc: String(desc || ''),
        price,
        originalPrice,
        sales,
        img: String(coverImage || '') || defaultCourseCover,
        kind: 'product',
        raw: item
      }
    },
    async fetchList() {
      if (this.loading) return
      this.loading = true
      try {
        if (this.level1 === '课程') {
          const keyword = String(this.keyword || '').trim()
          const params = { pageNum: this.page, pageSize: this.pageSize }
          if (keyword) params.keyword = keyword
          if (this.priceMin != null && this.priceMin !== '') params.minPrice = this.priceMin
          if (this.priceMax != null && this.priceMax !== '') params.maxPrice = this.priceMax

          const parentNode = this.level2 !== '全部' ? this.findCategoryNodeByName(this.level2) : null
          if (parentNode && parentNode.id != null) {
            params.parentCategoryId = parentNode.id
          }

          if (this.level3 !== '全部') {
            const categoryId =
              this.findCategoryIdByName(this.level3, parentNode && parentNode.children ? parentNode.children : this.courseCategoryTree)
            if (categoryId != null) {
              params.categoryId = categoryId
            }
          }

          const res = await getCourseList(params)
          const data = res && res.data != null ? res.data : null
          const list = Array.isArray(data) ? data : (data && Array.isArray(data.list) ? data.list : [])
          this.totalProducts = data && data.total != null ? Number(data.total) : list.length
          this.products = list.map(item => this.normalizeCourseItem(item))
          return
        }

        if (this.level1 === '模拟试卷') {
          const params = { pageNum: this.page, pageSize: this.pageSize, paperType: [2, 3] }
          if (this.priceMin != null && this.priceMin !== '') params.minPrice = this.priceMin
          if (this.priceMax != null && this.priceMax !== '') params.maxPrice = this.priceMax

          const parentNode = this.level2 !== '全部' ? this.findCategoryNodeByName(this.level2) : null
          if (this.level3 !== '全部') {
            const categoryId =
              this.findCategoryIdByName(this.level3, parentNode && parentNode.children ? parentNode.children : this.courseCategoryTree)
            if (categoryId != null) params.categoryId = categoryId
          } else if (parentNode && parentNode.id != null) {
            params.parentCategoryId = parentNode.id
          }

          const res = await getPaperList(params)
          const data = res && res.data != null ? res.data : null
          const list = Array.isArray(data) ? data : (data && Array.isArray(data.list) ? data.list : [])
          this.totalProducts = data && data.total != null ? Number(data.total) : list.length
          this.products = list.map(item => this.normalizePaperItem(item))
          return
        }

        if (this.level1 === '班级') {
          const keyword = String(this.keyword || '').trim()
          const params = { pageNum: this.page, pageSize: this.pageSize }
          if (keyword) params.className = keyword

          const parentNode = this.level2 !== '全部' ? this.findCategoryNodeByName(this.level2) : null
          if (this.level3 !== '全部') {
            const categoryId =
              this.findCategoryIdByName(this.level3, parentNode && parentNode.children ? parentNode.children : this.classCategoryTree)
            if (categoryId != null) params.categoryId = categoryId
          } else if (parentNode && parentNode.id != null) {
            params.parentCategoryId = parentNode.id
          }

          const res = await getClassList(params)
          const data = res && res.data != null ? res.data : null
          const list = Array.isArray(data) ? data : (data && Array.isArray(data.list) ? data.list : [])
          this.totalProducts = data && data.total != null ? Number(data.total) : list.length
          this.products = list.map(item => this.normalizeClassItem(item))
          return
        }

        if (this.level1 === '商品') {
          const params = {
            pageNum: this.page,
            pageSize: this.pageSize,
            sortType: this.productSortType || 'salesCount',
            sortOrder: this.productSortOrder || 'desc'
          }
          
          const categoryId = this.level2 !== '全部' ? this.findMallCategoryIdByName(this.level2) : null
          if (categoryId != null) params.categoryId = categoryId
          
          const productName = String(this.keyword || '').trim()
          if (productName) params.productName = productName

          const res = await getMallProductList(params)
          const data = res && res.data != null ? res.data : null
          const list = Array.isArray(data) ? data : (data && Array.isArray(data.list) ? data.list : [])
          this.totalProducts = data && data.total != null ? Number(data.total) : list.length
          this.products = list.map(item => this.normalizeMallProductItem(item))
          return
        }

        this.products = []
        this.totalProducts = 0
      } catch (err) {
        this.products = []
        this.totalProducts = 0
        const fallback =
          this.level1 === '商品'
            ? '获取商品列表失败'
            : this.level1 === '模拟试卷'
              ? '获取试卷列表失败'
              : '获取课程列表失败'
        this.$message.error((err && err.message) || fallback)
      } finally {
        this.loading = false
        this.persistFiltersToSession()
      }
    },
    goLearn(p) {
      this.$router.push({ name: 'learn', params: { id: p.id } })
    },
    goBuy(p) {
      if (!this.$store.getters['auth/isLoggedIn']) {
        this.loginVisible = true
        return
      }
      this.purchaseBizType = 'course'
      this.purchaseItemId = p.id
      this.purchaseTitle = p.title || ''
      this.purchaseImage = p.img || ''
      this.purchasePrice = Number(p.price || 0)
      this.$router.push({
        name: 'purchaseConfirm',
        params: { type: 'course', id: p.id }
      })
    },
    goBuyPaper(p) {
      const id = p && p.id != null ? p.id : null
      if (id == null || id === '') return

      if (!this.$store.getters['auth/isLoggedIn']) {
        this.loginVisible = true
        return
      }

      this.$router.push({
        name: 'purchaseConfirm',
        params: { type: 'paper', id }
      })
    },
    handlePurchased() {
      this.fetchList()
    },
    goAction(p) {
      if (!p) return
      if (p.kind === 'course') {
        this.$router.push({ name: 'course', params: { id: p.id } })
        return
      }
      if (p.kind === 'product') {
        this.$router.push({ name: 'productDetail', params: { id: p.id } })
        return
      }
      if (p.kind === 'paper') {
        // 试卷：进入试卷详情页
        this.$router.push({ name: 'paperPurchase', params: { id: p.id } })
        return
      }
      if (p.kind === 'class') {
        this.$router.push({ name: 'classDetail', params: { id: p.id } })
        return
      }
    },
    getActionText(p) {
      if (!p) return '查看'
      if (p.kind === 'course') return p.isPurchased ? '立即学习' : '立即购买'
      if (p.kind === 'product') return '查看商品'
      if (p.kind === 'paper') return p.isPurchased ? '开始答题' : '立即购买'
      if (p.kind === 'class') return '查看班级'
      return '查看'
    },
    buyPromoCourse() {
      const promo = this.products[0]
      if (promo) {
        this.goAction(promo)
      }
    },
    applyPrice() {
      this.page = 1
      this.fetchList()
    },
    resetFilters() {
      this.level1 = '课程'
      this.level2 = '全部'
      this.level3 = '全部'
      this.keyword = ''
      this.priceMin = null
      this.priceMax = null
      this.productSortType = 'salesCount'
      this.productSortOrder = 'desc'
      this.page = 1
      this.fetchList()
    },
    // 处理三级分类下拉菜单点击
    handleLevel3Command(command) {
      this.level3 = command
      this.page = 1
    },
    handlePageChange(nextPage) {
      this.page = nextPage
      this.fetchList()
    },
    getThumb(p) { return (p && p.img) || defaultCourseCover }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; margin-top: 0; }

.topbar { background: #fff; border-bottom: 1px solid #ebeef5; }
.topbar-inner { padding: 0 0 20px 0; }
.study-carousel {
  margin-bottom: 20px;
  /* border-radius: 8px; */
  /* overflow: hidden; */
  /* box-shadow: 0 4px 12px rgba(0,0,0,0.08); */
}
.carousel-slide {
  height: 360px;
  background: #fff;
  position: relative;
}
.overlay {
  position: absolute;
  left: 8%;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
}
.carousel-item-content {
  display: none;
}
.banner { display: flex; align-items: center; justify-content: space-between; background: linear-gradient(90deg,#3E2CCD,#6A5AF9); color: #fff; border-radius: 8px; padding: 14px 16px; min-height: 72px; }
.banner-text { font-weight: 600; }

.filters { margin-top: 16px; background: #f7f7fa; border: 1px solid #ebeef5; border-radius: 8px; padding: 12px; }
.tabs {
  display: flex;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  padding-bottom: 0;
}
.tab-item {
  padding: 12px 32px;
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  font-weight: 500;
  margin-right: 0;
}
.tab-item:hover {
  color: #3E2CCD;
}
.tab-item.active {
  color: #fff;
  background-color: #3E2CCD;
  font-weight: 600;
}
.tab-item.active::after {
  display: none;
}
.row { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; flex-wrap: wrap; }
.label { color: #606266; flex-shrink: 0; }
.filter-link { color: #3E2CCD; cursor: pointer; white-space: nowrap; }
.filter-link.active { font-weight: 600; }
.chips { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.chips .filter-link { margin-right: 0; }
.chips .el-tag { cursor: pointer; border-color: #e5e7eb; white-space: nowrap; }
.chips .el-tag.active { background: #3E2CCD; color: #fff; border-color: #3E2CCD; }
.more-toggle { color: #606266; cursor: pointer; }
.price-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 10px;
}

.course-title {
  margin-top: 10px;

}

.price-row .row {
  margin-bottom: 0;
}

.price-row .el-button { margin-left: 6px; }

::v-deep(.el-button--primary) { background-color: #3E2CCD; border-color: #3E2CCD; }
::v-deep(.el-button--primary:hover) { filter: brightness(1.05); }

.list { padding: 24px 0; margin-bottom: 60px; }
.promo { display: flex; align-items: center; justify-content: space-between; background: #fff7ed; border: 1px dashed #fdba74; border-radius: 8px; padding: 12px 16px; margin-bottom: 14px; }
.promo-text { color: #9a3412; font-weight: 600; }

.grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
.ui-card { border-radius: 12px; border: 1px solid #eae7ff; box-shadow: 0 6px 16px rgba(62,44,205,.08); overflow: hidden; }
.thumb { position: relative; height: 140px; border-radius: 8px; overflow: hidden; }
.thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.thumb-discount {
  position: absolute;
  left: 0px;
  bottom: 0px;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  background: linear-gradient(90deg, #4d6bff, #2e55ff);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 0px 20px 0px 0px;
  box-shadow: 0 6px 16px rgba(46, 85, 255, 0.25);
  pointer-events: none;
}
.badge-row { display: flex; align-items: center; justify-content: space-between; margin-top: 10px; }
.course-title { font-size: 14px; font-weight: 700; color: #303133; margin-top: 8px; line-height: 1.35; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; }
.discount { display: inline-block; background: #f0ecff; color: #3E2CCD; font-weight: 600; border: 1px solid #eae7ff; border-radius: 6px; padding: 2px 8px; }
.discount.hot { background: #fff3d6; color: #9a3412; border-color: #ffe2a8; }
.sales { color: #606266; font-size: 12px; }
.desc { font-size: 13px; color: #606266; margin-top: 8px; min-height: 36px; }
.price { color: #ef4444; font-weight: 700; margin-top: 8px; }
.buy-btn {
  width: 100%;
  margin-top: 12px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  background: #fff !important;
  border: 1px solid #6A5AF9 !important;
  color: #6A5AF9 !important;
  font-size: 14px;
  font-weight: 500;
}

.buy-btn:hover,
.buy-btn:focus {
  background: #f5f3ff !important;
  border-color: #6A5AF9 !important;
  color: #6A5AF9 !important;
}

.buy-btn:active {
  background: #ede9fe !important;
  border-color: #6A5AF9 !important;
  color: #6A5AF9 !important;
}

.buy-btn.is-disabled,
.buy-btn.is-disabled:hover,
.buy-btn.is-disabled:focus {
  background: #fff !important;
  border-color: #e5e7eb !important;
  color: #c0c4cc !important;
}

.pager { display: flex; justify-content: center; margin-top: 16px; }

@media (max-width: 992px) {
  .grid { grid-template-columns: repeat(2, 1fr); }
}

.banner .el-button {
  background-color: #fff;
  color: #3E2CCD;
  border: none;
  font-weight: 600;
}

/* Book Card Styles */
.is-product .thumb {
  height: 220px; /* Taller for book covers */
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.is-product .thumb img {
  width: auto;
  height: 100%;
  max-width: 100%;
  object-fit: contain; /* Ensure whole book cover is visible */
  transition: transform 0.3s;
}

.is-product:hover .thumb img {
  transform: scale(1.05);
}

.is-product .course-title {
  font-size: 15px;
  line-height: 1.4;
  height: 42px; /* 2 lines */
  margin-top: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
}

.product-sales {
  font-size: 12px;
  color: #909399;
  margin-top: 8px;
}

.product-divider {
  border-top: 1px dashed #ebeef5;
  margin: 12px 0;
}

.product-price-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 12px;
}

.product-price-row .price {
  color: #F56C6C;
  font-size: 18px;
  font-weight: 700;
  margin-top: 0;
}

.product-price-row .original-price {
  color: #C0C4CC;
  font-size: 12px;
  text-decoration: line-through;
}

.product-btn {
  width: 100%;
  border-radius: 20px; /* Rounded button */
  background-color: #3E2CCD !important;
  border-color: #3E2CCD !important;
  color: #fff !important;
  font-weight: 600;
  margin-top: 0;
}

.product-btn:hover {
  background-color: #5342e0 !important;
  border-color: #5342e0 !important;
  opacity: 0.9;
}

/* Popup Ad */
::v-deep .ad-popup-dialog {
  background: transparent;
  box-shadow: none;
}
::v-deep .ad-popup-dialog .el-dialog__header {
  display: none;
}
::v-deep .ad-popup-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
}

.ad-popup-content {
  position: relative;
  text-align: center;
}

.ad-popup-content .ad-image {
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
}

.ad-popup-content .ad-image img {
  max-width: 100%;
  display: block;
}

.ad-popup-content .ad-close {
  margin-top: 16px;
  font-size: 36px;
  color: #fff;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.ad-popup-content .ad-close:hover {
  opacity: 1;
}

/* Float Ad */
.float-ad {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 2000;
  width: 200px; /* Adjust as needed */
}

.float-ad-content {
  position: relative;
}

.float-ad-content .ad-image {
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.float-ad-content .ad-image img {
  width: 100%;
  display: block;
}

.float-ad-content .ad-close {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 24px;
  height: 24px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}
</style>
